import { observer } from 'mobx-react-lite'
import { Status } from 'shared/ui'

type IStatusProps = {
  isActive: boolean
  className?: string
}

export const WebhookStatus = observer(({ isActive, className }: IStatusProps) => {
  const title = isActive ? 'Active' : 'Disabled'
  const intent = isActive ? 'positive' : 'neutral'
  const icon = isActive ? 'check2' : 'minusCircle'

  return <Status emphasis='high' intent={intent} title={title} icon={icon} className={className} />
})
